// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"40cfab40c45756f64159","691":"4b5a49b48cde9bfa9f72"}[chunkId] + ".js";
};